import { left, right } from 'fp-ts/Either';
import { httpClientFunction } from 'domain/types';
import Logo from 'domain/entity/logo';
import ReadLogoClient from 'use-case/logos/read/readLogosClient';
import { isNoReportLogosPlaceholder } from 'use-case/logos/read/noReportLogosPlaceholder';

const readLogosApiClient = (httpClient: httpClientFunction, baseUrl: string): ReadLogoClient => () => {
    const urlWithoutApiv3 = baseUrl.replace('/api-v3', '');
    return httpClient(`${urlWithoutApiv3}/reports/logos`, {})
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then(asLogos)
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));
};

const asLogos = (logosJson: LogoJson[]): Logo[] =>
    logosJson
        .filter(
            (logo): logo is LogoJson & { imgResourceKey: string } =>
                !isNoReportLogosPlaceholder(logo) && logo.imgResourceKey !== null
        )
        .map((logo) => new Logo(String(logo.id), logo.name, logo.imgResourceKey));

export type LogoJson = {
    id: string | number;
    name: string;
    imgResourceKey: string | null;
};

export default readLogosApiClient;
